const schedule = {
  meta: {},
  schedule: [
    {
      overview: {
        no: 1,
        summary: `Welcome to New York. On arrival at New York, You will be welcomed by your Tour manager or Representative and taken to your hotel. Overnight at Quality inn Edison in New Jersey or similar.`,
        title: 'Welcome To New York',
        startLoc: 'New York',
        endLoc: 'New Jersey',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: ' Quality inn Edison, New Jersey',
        map: 'https://www.google.com/maps/place/Quality+Inn+Edison-New+Brunswick/@40.5264831,-74.3637127,17z/data=!3m1!4b1!4m8!3m7!1s0x89c3c82b64cde0d7:0x9304aaa7db517894!5m2!4m1!1i2!8m2!3d40.526479!4d-74.361524',
        contactNo: '',
        startDate: '9 May, 2020',
        endDate: '10 May 2020'
      },
      attractions: [
        {
          name: 'Arrival at New York',
          map: 'https://www.google.com/maps/place/New+York,+NY,+USA/@40.6976637,-74.1197637,11z/data=!3m1!4b1!4m5!3m4!1s0x89c24fa5d33f083b:0xc80b8f06e177fe62!8m2!3d40.7127753!4d-74.0059728',
          pics: [
            '1-1-1.jpg',
            '1-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=new+york&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'New York City (NYC), also known as the City of New York or simply New York (NY), is the most populous city in the United States. With an estimated 2018 population of 8,398,748 distributed over a land area of about 302.6 square miles (784 km2), New York is also the most densely populated major city in the United States.',
          wiki: 'https://en.wikipedia.org/wiki/New_York_City',
        }
      ]
    },
    {
      overview: {
        no: 2,
        summary: `Today, take a boat cruise to the Liberty Island to view “The Statue of Liberty”. Get a chance to visit the One World Trade Centre. Next, proceed on a guided city tour of Manhattan, drive past Brooklyn and Manhattan Bridges, United Nations Headquarters, Trump Towers, Central Park, the Times Square etc.`,
        title: 'Statue Of Liberty, City Tour of New York',
        startLoc: 'New York',
        endLoc: 'New Jersey',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: ' Quality inn Edison, New Jersey',
        map: 'https://www.google.com/maps/place/Quality+Inn+Edison-New+Brunswick/@40.5264831,-74.3637127,17z/data=!3m1!4b1!4m8!3m7!1s0x89c3c82b64cde0d7:0x9304aaa7db517894!5m2!4m1!1i2!8m2!3d40.526479!4d-74.361524',
        contactNo: '',
        startDate: '9 May, 2020',
        endDate: '10 May 2020'
      },
      attractions: [
        {
          name: 'boat cruise to the Liberty Island to view “The Statue of Liberty”',
          map: 'https://www.google.com/maps/place/Statue+of+Liberty+National+Monument/@40.6892534,-74.0466891,17z/data=!3m1!4b1!4m5!3m4!1s0x89c25090129c363d:0x40c6a5770d25022b!8m2!3d40.6892494!4d-74.0445004',
          pics: [
            '2-1-1.jpg',
            '2-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=liberty+island&t=h_&iax=images&ia=images&iaf=layout%3ATall',
          summary: 'Liberty Island is a federally owned island in Upper New York Bay in the United States. Its most notable feature is the Statue of Liberty (Liberty Enlightening the World), a large statue by Frédéric Auguste Bartholdi that was dedicated in 1886. Part of New York State, the island is an exclave of the New York City borough of Manhattan, surrounded by the waters of Jersey City, New Jersey. Long known as Bedloe"s Island, it was renamed by an act of the United States Congress in 1956.',
          wiki: 'https://en.wikipedia.org/wiki/Liberty_Island',
        },
        {
          name: 'visit the One World Trade Centre',
          map: 'https://www.google.com/maps/place/One+World+Trade+Center/@40.7129987,-74.0153496,17z/data=!3m1!4b1!4m5!3m4!1s0x89c25a197c06b7cb:0x40a06c78f79e5de6!8m2!3d40.7127431!4d-74.0133795',
          pics: [
            '2-2-1.jpg',
            '2-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=one+world+trade+center&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'One World Trade Center (also known as One WTC or Freedom Tower)[note 1] is the main building of the rebuilt World Trade Center complex in Lower Manhattan, New York City. One WTC is the tallest building in the United States, the tallest building in the Western Hemisphere, and the seventh-tallest in the world.',
          wiki: 'https://en.wikipedia.org/wiki/Liberty_Island',
        },
        {
          name: ' guided city tour of Manhattan',
          map: 'https://www.google.com/maps/place/Manhattan,+New+York,+NY,+USA/@40.7591704,-74.0392706,12z/data=!3m1!4b1!4m5!3m4!1s0x89c2588f046ee661:0xa0b3281fcecc08c!8m2!3d40.7830603!4d-73.9712488',
          pics: [
            '2-3-1.jpg',
            '2-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=manhattan&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Manhattan (/mænˈhætən, mən-/), often referred to by residents of the New York City area as the City,[1] is the most densely populated of the five boroughs of New York City, and coextensive with the County of New York, one of the original counties of the U.S. state of New York. Manhattan serves as the city"s economic and administrative center, cultural identifier,[6] and historical birthplace.[7]',
          wiki: 'https://en.wikipedia.org/wiki/Manhattan',
        },
        {
          name: 'drive past Brooklyn bridge',
          map: 'https://www.google.com/maps/place/Brooklyn+Bridge/@40.7058134,-73.9981622,17z/data=!3m1!4b1!4m5!3m4!1s0x89c25a2343ce7b2b:0x2526ddba7abd465c!8m2!3d40.7060855!4d-73.9968643',
          pics: [
            '2-4-1.jpg',
            '2-4-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=brooklyn+bridge&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Brooklyn Bridge is a hybrid cable-stayed/suspension bridge in New York City, spanning the East River between the boroughs of Manhattan and Brooklyn.',
          wiki: 'https://en.wikipedia.org/wiki/Brooklyn_Bridge',
        },
        {
          name: 'drive past Manhattan Bridge',
          map: 'https://www.google.com/maps/place/Manhattan+Bridge/@40.7069926,-73.9935136,17z/data=!3m1!4b1!4m5!3m4!1s0x89c25a2e3b75514b:0x7be54ad37a019fcf!8m2!3d40.7074959!4d-73.9907742',
          pics: [
            '2-5-1.jpg',
            '2-5-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=manhattan+bridge+new+york&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Manhattan Bridge is a suspension bridge that crosses the East River in New York City, connecting Lower Manhattan at Canal Street with Downtown Brooklyn at the Flatbush Avenue Extension. ',
          wiki: 'https://en.wikipedia.org/wiki/Manhattan_Bridge',
        },
        {
          name: 'drive past United Nations Headquarters',
          map: 'https://www.google.com/maps/place/United+Nations+Headquarters/@40.7488798,-73.9701978,17z/data=!3m1!4b1!4m5!3m4!1s0x89c2591ce0874d11:0xc5fae28bdd3df635!8m2!3d40.7488758!4d-73.9680091',
          pics: [
            '2-6-1.jpg',
            '2-6-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=United+Nations+Headquarters&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The United Nations is headquartered in New York City, in a complex designed by a board of architects led by Wallace Harrison, and built by the architectural firm Harrison & Abramovitz. The complex has served as the official headquarters of the United Nations since its completion in 1952. It is located in the Turtle Bay neighborhood of Manhattan.',
          wiki: 'https://en.wikipedia.org/wiki/United_Nations_Headquarters',
        },
        {
          name: 'drive past Trump Towers',
          map: 'https://www.google.com/maps/place/Trump+Tower/@40.7624324,-73.9759827,17z/data=!3m1!4b1!4m5!3m4!1s0x89c258faf553cfad:0x8e9cfc7444d8f876!8m2!3d40.7624284!4d-73.973794',
          pics: [
            '2-7-1.jpg',
            '2-7-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=trump+towers+new+york&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Trump Tower is a 58-floor, 664-foot-tall (202 m) mixed-use skyscraper at 721–725 Fifth Avenue, between 56th and 57th Streets, in Midtown Manhattan, New York City. Trump Tower serves as the headquarters for the Trump Organization. ',
          wiki: 'https://en.wikipedia.org/wiki/Trump_Tower',
        },
        {
          name: 'drive past Central Park',
          map: 'https://www.google.com/maps/place/Central+Park/@40.7828687,-73.9675438,17z/data=!3m1!4b1!4m5!3m4!1s0x89c2589a018531e3:0xb9df1f7387a94119!8m2!3d40.7828647!4d-73.9653551',
          pics: [
            '2-8-1.jpg',
            '2-8-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=central+park+new+york&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Central Park is an urban park in Manhattan, New York City, located between the Upper West Side and the Upper East Side. Central Park is the most visited urban park in the United States, with an estimated 37.5–38 million visitors annually, and one of the most filmed locations in the world. ',
          wiki: 'https://en.wikipedia.org/wiki/Central_Park',
        },
        {
          name: 'drive past Times Square',
          map: 'https://www.google.com/maps/place/Times+Square/@40.7579787,-73.9877313,17z/data=!3m1!4b1!4m5!3m4!1s0x89c25855c6480299:0x55194ec5a1ae072e!8m2!3d40.7579747!4d-73.9855426',
          pics: [
            '2-9-1.jpg',
            '2-9-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=times+square+new+york&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Times Square is a major commercial intersection, tourist destination, entertainment center, and neighborhood in the Midtown Manhattan section of New York City, at the junction of Broadway and Seventh Avenue. Brightly lit by numerous billboards and advertisements, it stretches from West 42nd to West 47th Streets,[2] and is sometimes referred to as "the Crossroads of the World",[3] "the Center of the Universe",[4] "the heart of the Great White Way",[5][6][7] and "the heart of the world".',
          wiki: 'https://en.wikipedia.org/wiki/Times_Square',
        },
      ]
    },
    {
      overview: {
        no: 3,
        summary: `Today, we drive to Washington D.C. Later, we proceed on a guided city tour of this historic city. Visit the U.S. Capitol hill; White House, the residence of the President of USA; see the Korean and Lincoln memorials and the beautiful WWII memorial and many more sights on your city tour. Visit the Smithsonian Air and Space Museum.`,
        title: 'Tour Of Washington DC, Smithsonian Museum, Air Space Museum',
        startLoc: 'New Jersey',
        endLoc: 'Washington DC',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: ' Springhill Suites by Marriott Gaithersburg, Washington, D.C.',
        map: 'https://www.google.com/maps/place/SpringHill+Suites+by+Marriott+Gaithersburg/@39.113148,-77.194327,17z/data=!3m1!4b1!4m8!3m7!1s0x89b7d2ab7938eb7f:0xa777c6542903080d!5m2!4m1!1i2!8m2!3d39.1131439!4d-77.1921383',
        contactNo: '',
        startDate: '10 May, 2020',
        endDate: '11 May 2020'
      },
      attractions: [
        {
          name: 'Drive to and guided city tour of Washington D.C',
          map: 'https://www.google.com/maps/place/Washington,+DC,+USA/@38.8937091,-77.0846157,12z/data=!3m1!4b1!4m5!3m4!1s0x89b7c6de5af6e45b:0xc2524522d4885d2a!8m2!3d38.9071923!4d-77.0368707',
          pics: [
            '3-1-1.jpg',
            '3-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=washington+dc&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Washington, D.C., (/ˈwɑːʃɪŋtən ˌdiːˈsiː/) formally the District of Columbia and commonly referred to as D.C., Washington, or The District, is the capital of the United States.[6] Founded after the American Revolution as the seat of government of the newly independent country, Washington was named after George Washington, the first president of the United States and a Founding Father.[7]',
          wiki: 'https://en.wikipedia.org/wiki/Washington,_D.C.',
        },
        {
          name: ' Visit the U.S. Capitol hill',
          map: 'https://www.google.com/maps/place/Capitol+Hill/@38.8895722,-77.0181754,15z/data=!3m1!4b1!4m5!3m4!1s0x89b7b829c469e329:0x2b85169381fa9d8b!8m2!3d38.8895563!4d-77.0094206',
          pics: [
            '3-2-1.jpg',
            '3-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=us+capitol+hill&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The United States Capitol, often called the Capitol Building, is the home of the United States Congress and the seat of the legislative branch of the U.S. federal government. It is located on Capitol Hill at the eastern end of the National Mall in Washington, D.C.',
          wiki: 'https://en.wikipedia.org/wiki/United_States_Capitol',
        },
        {
          name: ' Visit the White House',
          map: 'https://www.google.com/maps/place/The+White+House/@38.8976805,-77.0387185,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7b7bcdecbb1df:0x715969d86d0b76bf!8m2!3d38.8976763!4d-77.0365298',
          pics: [
            '3-3-1.jpg',
            '3-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=white+house&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The White House is the official residence and workplace of the president of the United States. It is located at 1600 Pennsylvania Avenue NW in Washington, D.C. and has been the residence of every U.S. president since John Adams in 1800. ',
          wiki: 'https://en.wikipedia.org/wiki/White_House',
        },
        {
          name: ' see the Korean memorials ',
          map: 'https://www.google.com/maps/place/Korean+War+Veterans+Memorial/@38.8878261,-77.0499784,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7b7a832df3d15:0x99aa7d9dc2d7e737!8m2!3d38.8878219!4d-77.0477897',
          pics: [
            '3-4-1.jpg',
            '3-4-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=korean+memorials+dc&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Korean War Veterans Memorial is located in Washington, D.C."s West Potomac Park, southeast of the Lincoln Memorial and just south of the Reflecting Pool on the National Mall. It memorializes those who served in the Korean War.',
          wiki: 'https://en.wikipedia.org/wiki/Korean_War_Veterans_Memorial',
        },
        {
          name: ' see the Lincoln memorials ',
          map: 'https://www.google.com/maps/place/Lincoln+Memorial/@38.8892728,-77.0523647,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7b771e0906287:0x1049d1c9c95c2eb6!8m2!3d38.8892686!4d-77.050176',
          pics: [
            '3-5-1.jpg',
            '3-5-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=lincoln+memorial&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Lincoln Memorial is an American national memorial built to honor the 16th President of the United States, Abraham Lincoln. It is located on the western end of the National Mall in Washington, D.C., across from the Washington Monument.',
          wiki: 'https://en.wikipedia.org/wiki/Lincoln_Memorial',
        },
        {
          name: 'See  WWII memorial ',
          map: 'https://www.google.com/maps/place/World+War+II+Memorial/@38.8894131,-77.0410998,19z/data=!3m1!4b1!4m5!3m4!1s0x89b7b7a6dd314ea1:0x459afc10e0ec7876!8m2!3d38.8894206!4d-77.0404978',
          pics: [
            '3-6-1.jpg',
            '3-6-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=world+war+ii+memorial+dc&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The World War II Memorial is a memorial of national significance[1][2] dedicated to Americans who served in the armed forces and as civilians during World War II. Consisting of 56 pillars and a pair of small triumphal arches surrounding a square and fountain, it sits on the National Mall in Washington, D.C.,',
          wiki: 'https://en.wikipedia.org/wiki/World_War_II_Memorial',
        },
        {
          name: ' Visit the Smithsonian Air and Space Museum',
          map: 'https://www.google.com/maps/place/Smithsonian+National+Air+and+Space+Museum/@38.8881643,-77.0220566,17z/data=!3m2!4b1!5s0x89b7b78371c4054d:0xe8c76fea9e5a064b!4m5!3m4!1s0x89b7b7837b262421:0xf8e7c937dd8ce81b!8m2!3d38.8881601!4d-77.0198679',
          pics: [
            '3-7-1.jpg',
            '3-7-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=smithsonian+air+and+space+dc&t=h_&iax=images&ia=images&iaf=layout%3ATall',
          summary: 'The National Air and Space Museum of the Smithsonian Institution, also called the Air and Space Museum, is a museum in Washington, D.C. It was established in 1946 as the National Air Museum and opened its main building on the National Mall near L"Enfant Plaza in 1976. ',
          wiki: 'https://en.wikipedia.org/wiki/National_Air_and_Space_Museum',
        },
      ]
    },
    {
      overview: {
        no: 4,
        summary: `Today, we proceed for a visit to the Hershey’s Chocolate World. Later we drive towards Buffalo. `,
        title: 'Visit Hershey’s Chocolate World. Drive to Buffalo',
        startLoc: 'New York',
        endLoc: 'New Jersey',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: ' Hampton Inn Buffalo',
        map: 'https://www.google.com/maps/place/Hampton+Inn+Buffalo-Airport%2FGalleria+Mall/@42.9074737,-78.7745735,17z/data=!3m1!4b1!4m8!3m7!1s0x89d30ceb73a698f5:0x257db0d5533cc1b2!5m2!4m1!1i2!8m2!3d42.9074698!4d-78.7723848',
        contactNo: '',
        startDate: '11 May, 2020',
        endDate: '12 May 2020'
      },
      attractions: [
        {
          name: 'Hershey’s Chocolate World',
          map: 'https://www.google.com/maps/place/Hershey"s+Chocolate+World/@43.0922783,-79.0732593,17z/data=!3m1!4b1!4m5!3m4!1s0x89d34319245d8275:0x8930f51864d2de6c!8m2!3d43.0922744!4d-79.0710706',
          pics: [
            '4-1-1.jpg',
            '4-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=hershey+chocolate+world&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Hershey’s Chocolate World is the name of eight visitor centers that started in Hershey, Pennsylvania, United States. Open year-round, Hershey"s Chocolate World offers marketplace shops and restaurants, specializing in Hershey"s chocolate products.',
          wiki: 'https://en.wikipedia.org/wiki/Hershey%27s_Chocolate_World',
        },
        {
          name: 'drive towards Buffalo',
          map: 'https://www.google.com/maps/place/Buffalo,+NY,+USA/@42.8963434,-78.9344819,12z/data=!3m1!4b1!4m5!3m4!1s0x89d3126152dfe5a1:0x982304a5181f8171!8m2!3d42.8864468!4d-78.8783689',
          pics: [
            '4-2-1.jpg',
            '4-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=buffalo+new+york&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Buffalo is the second largest city in the U.S. state of New York and the largest city in Western New York. As of 2018, the population was 256,304. The city is the county seat of Erie County and a major gateway for commerce and travel across the Canada–United States border, forming part of the bi-national Buffalo Niagara Region. ',
          wiki: 'https://en.wikipedia.org/wiki/Buffalo,_New_York',
        }
      ]
    },
    {
      overview: {
        no: 5,
        summary: `After breakfast, we take you to Niagara Falls to enjoy boat ride aboard the ‘Maid of The Mist’. (Due to weather conditions, this ride usually operates only after the 2nd week of May.) We offer the ‘Niagara Scenic Trolley’ instead, for all tourists visiting the falls prior to the commencement of the ride. Proceed to the airport for your flight to San Francisco /Oakland. `,
        title: 'Niagra Falls Boat Ride, Flight To San Fransisco',
        startLoc: 'Buffalo',
        endLoc: 'San Fransisco',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: 'La Quinta Inn & Suites, Oakland, CA, USA',
        map: 'https://www.google.com/maps/place/La+Quinta+Inn+%26+Suites+by+Wyndham+Oakland+Airport+Coliseum/@37.7293974,-122.2092556,13.03z/data=!4m8!3m7!1s0x808f8594446498e3:0x53a345f6cdacb457!5m2!4m1!1i2!8m2!3d37.7426847!4d-122.1939881',
        contactNo: '',
        startDate: '12 May 2020',
        endDate: '13 May 2020'
      },
      attractions: [
        {
          name: ' Niagara Falls',
          map: 'https://www.google.com/maps/place/Niagara+Falls,+NY,+USA/@43.0995628,-79.0437609,13z/data=!3m1!4b1!4m5!3m4!1s0x89d363ea29e633b7:0x61975ae4b9c5aab3!8m2!3d43.0962143!4d-79.0377388',
          pics: [
            '5-1-1.jpg',
            '5-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=niagara+falls&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Niagara Falls is a group of three waterfalls at the southern end of Niagara Gorge, spanning the border between the US state of New York and the Canadian province of Ontario. The largest of the three is Horseshoe Falls, also known as Canadian Falls, which straddles the international border between Canada and the United States.[1]',
          wiki: 'https://en.wikipedia.org/wiki/Niagara_Falls',
        },
        {
          name: 'Niagra falls boat ride Maid of the mist or Niagra Scenic trolley',
          map: 'https://www.google.com/maps/place/Maid+of+the+Mist+Boat+Tour/@43.0865125,-79.0701323,17z/data=!3m1!4b1!4m5!3m4!1s0x89d342fcee5049ad:0x1e02b43eab90b04!8m2!3d43.0865086!4d-79.0679436',
          pics: [
            '5-2-1.jpg',
            '5-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=maid+of+the+mist&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Maid of the Mist is a boat tour of Niagara Falls, starting and ending on the American side, crossing briefly into Ontario during a portion of the trip. (The actual boats used are also named Maid of the Mist, followed by a different Roman numeral in each case.)',
          wiki: 'https://en.wikipedia.org/wiki/Maid_of_the_Mist',
        },
        {
          name: 'flight to San Francisco /Oakland',
          map: 'https://www.google.com/maps/place/San+Francisco,+CA,+USA/@37.7577627,-122.4726194,13z/data=!3m1!4b1!4m5!3m4!1s0x80859a6d00690021:0x4a501367f076adff!8m2!3d37.7749295!4d-122.4194155',
          pics: [
            '5-3-1.jpg',
            '5-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=san+francisco&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'San Francisco, officially the City and County of San Francisco and colloquially known as SF, San Fran, Frisco, or The City,[19][20] is the cultural, commercial, and financial center of Northern California. San Francisco is the 15th-most populous city in the United States, and the fourth-most populous in California, with 883,305 residents as of 2018.[14]',
          wiki: 'https://en.wikipedia.org/wiki/San_Francisco',
        }
      ]
    },
    {
      overview: {
        no: 6,
        summary: `Today, proceed for a guided city tour. See the Civic Centre, Twin Peaks, Golden Gate Park. Later, drive to Fresno. `,
        title: 'Guided City Tour of San Francisco',
        startLoc: 'San Fransisco',
        endLoc: 'San Fransisco',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: 'La Quinta Inn & Suites, Fresno, CA, USA',
        map: 'https://www.google.com/maps/place/La+Quinta+Inn+%26+Suites+by+Wyndham+Fresno+Northwest/@36.8098002,-119.8833185,17z/data=!3m1!4b1!4m8!3m7!1s0x809468aaaef70b4d:0x8c9dfc28afeb4d9c!5m2!4m1!1i2!8m2!3d36.8097959!4d-119.8811298',
        contactNo: '',
        startDate: '13 May 2020',
        endDate: '14 May 2020'
      },
      attractions: [
        {
          name: 'guided city tour of san fransisco',
          map: 'https://www.google.com/maps/place/San+Francisco,+CA,+USA/@37.7577627,-122.4726194,13z/data=!3m1!4b1!4m5!3m4!1s0x80859a6d00690021:0x4a501367f076adff!8m2!3d37.7749295!4d-122.4194155',
          pics: [
            '6-1-1.jpg',
            '6-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=san+francisco&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'San Francisco, officially the City and County of San Francisco and colloquially known as SF, San Fran, Frisco, or The City,[19][20] is the cultural, commercial, and financial center of Northern California. San Francisco is the 15th-most populous city in the United States, and the fourth-most populous in California, with 883,305 residents as of 2018.[14]',
          wiki: 'https://en.wikipedia.org/wiki/San_Francisco',
        },
        {
          name: 'See the Civic Centre',
          map: 'https://www.google.com/maps/place/Civic+Center,+San+Francisco,+CA+94102,+USA/@37.7778616,-122.4222303,16z/data=!3m1!4b1!4m5!3m4!1s0x8085808eb456e2dd:0xcb1742ab59d38bda!8m2!3d37.7815533!4d-122.4156427',
          pics: [
            '6-2-1.jpg',
            '6-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Civic+Center%2C+San+Francisco&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Civic Center in San Francisco, California, is an area of a few blocks north of the intersection of Market Street and Van Ness Avenue that contains many of the city"s largest government and cultural institutions. It has two large plazas (Civic Center Plaza and United Nations Plaza) and a number of buildings in classical architectural style.',
          wiki: 'https://en.wikipedia.org/wiki/Civic_Center,_San_Francisco',
        },
        {
          name: 'See the Twin Peaks',
          map: 'https://www.google.com/maps/place/Twin+Peaks,+San+Francisco,+CA,+USA/@37.7532595,-122.4556606,16z/data=!3m1!4b1!4m5!3m4!1s0x808f7e08425fbda7:0x2d9e2665b504b657!8m2!3d37.7544066!4d-122.4476845',
          pics: [
            '6-3-1.jpg',
            '6-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Twin+Peaks+(San+Francisco)&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Twin Peaks are two prominent hills with an elevation of about 925 feet (282 m)[1] located near the geographic center of San Francisco, California. Only 928 foot (283 m) Mount Davidson is higher within the city.[3]',
          wiki: 'https://en.wikipedia.org/wiki/Twin_Peaks_(San_Francisco)',
        },
        {
          name: 'Golden Gate Bridge & Park',
          map: 'https://www.google.com/maps/place/Golden+Gate+Bridge/@37.8199328,-122.4804438,17z/data=!3m1!4b1!4m5!3m4!1s0x808586deffffffc3:0xcded139783705509!8m2!3d37.8199286!4d-122.4782551',
          pics: [
            '6-4-1.jpg',
            '6-4-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Golden+Gate+bridge&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Golden Gate Park, located in San Francisco, California, United States, is a large urban park consisting of 1,017 acres (412 ha) of public grounds. It is administered by the San Francisco Recreation & Parks Department, which began in 1871 to oversee the development of Golden Gate Park. ',
          wiki: 'https://en.wikipedia.org/wiki/Golden_Gate_Park',
        },
        {
          name: 'Drive to Fresno',
          map: 'https://www.google.com/maps/place/Fresno,+CA,+USA/@36.7856504,-119.8646011,12z/data=!3m1!4b1!4m5!3m4!1s0x80945de1549e4e9d:0x7b12406449a3b811!8m2!3d36.7377981!4d-119.7871247',
          pics: [
            '6-5-1.jpg',
            '6-5-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=fresno+california&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Fresno (/ˈfrɛznoʊ/ FREZ-noh; Spanish for "ash tree") is a city in and the county seat of Fresno County, California, United States. It covers about 112 square miles (290 km2)[12] in the center of the San Joaquin Valley, the southern portion of California"s Central Valley.',
          wiki: 'https://en.wikipedia.org/wiki/Fresno,_California',
        }
      ]
    },
    {
      overview: {
        no: 7,
        summary: `Today, drive to Las Vegas. On arrival, check-in to your hotel. Later you can explore the grandeur of your own hotel or you can just walk along the Las Vegas Boulevard - the main street. Visit Fremont Street`,
        title: 'Las Vegas',
        startLoc: 'San Fransisco',
        endLoc: 'Las Vegas',
      },
      dates: {
        startDate: '14 May 2020',
        endDate: '15 May 2020'
      },
      hotel: {
        name: 'Circus Circus, Reno, NV, USA',
        map: 'https://www.google.com/maps/place/Circus+Circus+Reno/@39.5321712,-119.8175487,17z/data=!3m1!4b1!4m8!3m7!1s0x809947369a6d96f1:0x8a35778e09b46c3e!5m2!4m1!1i2!8m2!3d39.5321671!4d-119.81536',
        contactNo: '',
        startDate: '14 May 2020',
        endDate: '15 May 2020'
      },
      attractions: [
        {
          name: 'drive to Las Vega',
          map: 'https://www.google.com/maps/place/Las+Vegas,+NV,+USA/@36.1251958,-115.3150831,11z/data=!3m1!4b1!4m5!3m4!1s0x80beb782a4f57dd1:0x3accd5e6d5b379a3!8m2!3d36.1699412!4d-115.1398296',
          pics: [
            '7-1-1.jpg',
            '7-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=las+vegas&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Las Vegas (Spanish for "The Meadows"), officially the City of Las Vegas and often known simply as Vegas, is the 28th-most populated city in the United States, the most populated city in the state of Nevada, and the county seat of Clark County. ',
          wiki: 'https://en.wikipedia.org/wiki/Las_Vegas',
        },
        {
          name: ' walk along the Las Vegas Boulevard - the main street',
          map: 'https://www.google.com/maps/place/Las+Vegas+Blvd+N,+Las+Vegas,+NV,+USA/@36.2093076,-115.1097898,17z/data=!3m1!4b1!4m5!3m4!1s0x80c8dd1c681ee615:0xe236ea44568b663f!8m2!3d36.2093033!4d-115.1076011',
          pics: [
            '7-2-1.jpg',
            '7-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=las+vegas+boulevard&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Las Vegas Boulevard is a major, world-famous road in the Las Vegas Valley of Nevada, best known for the Las Vegas Strip portion of the road and its casinos. ',
          wiki: 'https://en.wikipedia.org/wiki/Las_Vegas_Boulevard',
        },
        {
          name: ' Visit Fremont Street',
          map: 'https://www.google.com/maps/place/Fremont+Street+Experience/@36.1707924,-115.1464592,17z/data=!3m1!4b1!4m5!3m4!1s0x80c8c39fe106ae7b:0x19ef4a53d2cc5034!8m2!3d36.1707881!4d-115.1442705',
          pics: [
            '7-3-1.jpg',
            '7-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Fremont+Street+Experience&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Fremont Street Experience (FSE) is a pedestrian mall and attraction in downtown Las Vegas, Nevada. The FSE occupies the westernmost five blocks of Fremont Street, including the area known for years as "Glitter Gulch," and portions of some other adjacent streets.',
          wiki: 'https://en.wikipedia.org/wiki/Fremont_Street_Experience',
        },
      ]
    },
    {
      overview: {
        no: 8,
        summary: `Today, the entire day is free for you to explore themed hotels and shopping center’s on your own. Or, avail one of the exciting optional tours to the Grand Canyon.`,
        title: 'Grand Canyon (Optional)',
        startLoc: 'Las Vegas',
        endLoc: 'Las Vegas',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: 'Circus Circus, Reno, NV, USA',
        map: 'https://www.google.com/maps/place/Circus+Circus+Reno/@39.5321712,-119.8175487,17z/data=!3m1!4b1!4m8!3m7!1s0x809947369a6d96f1:0x8a35778e09b46c3e!5m2!4m1!1i2!8m2!3d39.5321671!4d-119.81536',
        contactNo: '',
        startDate: '15 May 2020',
        endDate: '16 May 2020'
      },
      special: {
        title: 'Grand Canyon',

      },
      attractions: [
        {
          name: 'Grand Canyon',
          map: '',
          pics: [
            '8-1.jpg',
            '8-3.jpg',
            '8-4.jpg',
            '8-5.jpg',
            '8-6.jpg',
            '8-7.jpg',
            '8-8.jpg',
            '8-9.jpg',
            '8-10.jpg',
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=grand+canyon&t=h_&iax=images&ia=images&iaf=layout%3ATall%2Csize%3ALarge',
          summary: 'The Grand Canyon (Hopi: Ongtupqa,[2] Yavapai: Wi:kaʼi:la, Navajo: Bidááʼ Haʼaztʼiʼ Tsékooh,[3][4] Spanish: Gran Cañón) is a steep-sided canyon carved by the Colorado River in Arizona, United States. The Grand Canyon is 277 miles (446 km) long, up to 18 miles (29 km) wide and attains a depth of over a mile (6,093 feet or 1,857 meters).[5]',
          wiki: 'https://en.wikipedia.org/wiki/Grand_Canyon',
        },
        
      ]
    },
    {
      overview: {
        no: 9,
        summary: `Today, we drive to Los Angeles. Later, we proceed for an orientation tour of Los Angeles. Visit the Hollywood Boulevard, walk along the Hollywood Walk of Fame. See the Dolby Theatre, the TCL Chinese theatre. Drive along the famous Sunset Strip and Beverly Hills area. `,
        title: 'Los Angeles, Hollywood Boulevard',
        startLoc: 'Las Vegas',
        endLoc: 'Los Angeles',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: 'Four Points by Sheraton, Los Angeles, CA, USA',
        map: 'https://www.google.com/maps/place/Four+Points+by+Sheraton+Los+Angeles+International+Airport/@33.9478964,-118.3872335,17z/data=!3m1!4b1!4m8!3m7!1s0x80c2b6d6f0f8d99b:0x2e42619821fb8a5b!5m2!4m1!1i2!8m2!3d33.947892!4d-118.3850448',
        contactNo: '',
        startDate: '16 May 2020',
        endDate: '17 May 2020'
      },
      attractions: [
        {
          name: 'drive to Los Angeles',
          map: 'https://www.google.com/maps/place/Los+Angeles,+CA,+USA/@34.0207305,-118.6919144,10z/data=!3m1!4b1!4m5!3m4!1s0x80c2c75ddc27da13:0xe22fdf6f254608f4!8m2!3d34.0522342!4d-118.2436849',
          pics: [
            '9-1-1.jpg',
            '9-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=los+angeles&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Los Angeles (/lɔːs ˈændʒələs/ (About this soundlisten);[a] Spanish: Los Ángeles; Spanish for "The Angels"),[16] officially the City of Los Angeles and often known by its initials L.A., is the most populous city in California; the second most populous city in the United States, after New York City; and the third-most populous city in North America, after Mexico City and New York City. ',
          wiki: 'https://en.wikipedia.org/wiki/Los_Angeles',
        },
        {
          name: 'City tour of Los Angeles',
          map: 'https://www.google.com/maps/place/Los+Angeles,+CA,+USA/@34.0207305,-118.6919144,10z/data=!3m1!4b1!4m5!3m4!1s0x80c2c75ddc27da13:0xe22fdf6f254608f4!8m2!3d34.0522342!4d-118.2436849',
          pics: [
            '9-2-1.jpg',
            '9-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=los+angeles&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Los Angeles (/lɔːs ˈændʒələs/ (About this soundlisten);[a] Spanish: Los Ángeles; Spanish for "The Angels"),[16] officially the City of Los Angeles and often known by its initials L.A., is the most populous city in California; the second most populous city in the United States, after New York City; and the third-most populous city in North America, after Mexico City and New York City. ',
          wiki: 'https://en.wikipedia.org/wiki/Los_Angeles',
        },
        {
          name: ' Visit the Hollywood Boulevard',
          map: 'https://www.google.com/maps/place/Hollywood+Blvd,+Los+Angeles,+CA,+USA/@34.1016277,-118.3303751,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2bf3b245207d5:0xae58054941bd8669!8m2!3d34.1016233!4d-118.3281864',
          pics: [
            '9-3-1.jpg',
            '9-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Hollywood+Boulevard&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Hollywood Boulevard is a major east–west street in Los Angeles, California. It begins in the west as a winding residential street at Sunset Plaza Drive in the Hollywood Hills West district. After crossing Laurel Canyon Boulevard, it proceeds due east as a major thoroughfare through Hollywood, Little Armenia and Thai Town to Vermont Avenue. ',
          wiki: 'https://www.google.com/maps/place/Hollywood+Blvd,+Los+Angeles,+CA,+USA/@34.1016277,-118.3303751,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2bf3b245207d5:0xae58054941bd8669!8m2!3d34.1016233!4d-118.3281864',
        },
        {
          name: 'walk along the Hollywood Walk of Fame',
          map: 'https://www.google.com/maps/place/Hollywood+Walk+Of+Fame+HQ/@34.0985303,-118.3277534,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2bf23e1797113:0x8311165829297f02!8m2!3d34.0985259!4d-118.3255647',
          pics: [
            '9-4-1.jpg',
            '9-4-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=hollywood+walk+of+fame&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Hollywood Walk of Fame comprises more than 2,600[1] five-pointed terrazzo and brass stars embedded in the sidewalks along 15 blocks of Hollywood Boulevard and three blocks of Vine Street in Hollywood, California. The stars are permanent public monuments to achievement in the entertainment industry, bearing the names of a mix of musicians, actors, directors, producers, musical and theatrical groups, fictional characters, and others. ',
          wiki: 'https://en.wikipedia.org/wiki/Hollywood_Walk_of_Fame',
        },
        {
          name: ' See the Dolby Theatre',
          map: 'https://www.google.com/maps/place/Dolby+Theatre/@34.1023799,-118.3424462,17z/data=!3m2!4b1!5s0x80c2bf23c7952b9f:0x64dca853c2a04780!4m5!3m4!1s0x80c2bf23c3bb14c7:0xf5f01d0d3b59ab76!8m2!3d34.1026919!4d-118.3404156',
          pics: [
            '9-5-1.jpg',
            '9-5-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Dolby+Theatre&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Dolby Theatre (formerly known as the Kodak Theatre) is a live-performance auditorium in the Hollywood and Highland Center shopping mall and entertainment complex, on Hollywood Boulevard and Highland Avenue, in the Hollywood district of Los Angeles.',
          wiki: 'https://en.wikipedia.org/wiki/Dolby_Theatre',
        },
        {
          name: 'see the TCL Chinese theatre',
          map: 'https://www.google.com/maps/place/TCL+Chinese+Theatre/@34.1020275,-118.3431599,17z/data=!3m2!4b1!5s0x80c2bf23c7952b9f:0x64dca853c2a04780!4m5!3m4!1s0x80dcd7da01c280c3:0xf73982db60c65ffb!8m2!3d34.1020231!4d-118.3409712',
          pics: [
            '9-6-1.jpg',
            '9-6-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=+TCL+Chinese+theatre&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'TCL Chinese Theatre is a movie palace on the historic Hollywood Walk of Fame at 6925 Hollywood Blvd. in Hollywood, California. Originally named and still commonly known as Grauman"s Chinese Theatre, it was renamed Mann"s Chinese Theatre in 1973; the name lasted until 2001, after which it reverted to its original name.',
          wiki: 'https://en.wikipedia.org/wiki/Grauman%27s_Chinese_Theatre',
        },
        {
          name: ' Drive along the famous Sunset Strip ',
          map: 'https://www.google.com/maps/place/Sunset+Strip,+West+Hollywood,+CA,+USA/@34.0938602,-118.3845026,16z/data=!3m1!4b1!4m5!3m4!1s0x80c2bebd1edae66f:0x1409fe931a9d4506!8m2!3d34.0912865!4d-118.3794303',
          pics: [
            '9-7-1.jpg',
            '9-7-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Sunset+Strip+LA&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Sunset Strip is the 1.5-mile (2.4 km) stretch of Sunset Boulevard that passes through the city of West Hollywood, California. It extends from West Hollywood"s eastern border with the city of Los Angeles (Hollywood) at Crescent Heights Boulevard to its western border with Beverly Hills at Sierra Drive. The Sunset Strip is known for its boutiques, restaurants, rock clubs, and nightclubs, as well as its array of huge, colorful billboards.',
          wiki: 'https://en.wikipedia.org/wiki/Sunset_Strip',
        },
        {
          name: ' Drive along the Beverly Hills area',
          map: 'https://www.google.com/maps/place/Beverly+Hills,+CA,+USA/@34.0825832,-118.4170435,14z/data=!3m1!4b1!4m5!3m4!1s0x80c2bc04d6d147ab:0xd6c7c379fd081ed1!8m2!3d34.0736204!4d-118.4003563',
          pics: [
            '9-8-1.jpg',
            '9-8-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Beverly+Hills&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Beverly Hills is a city in Los Angeles County, California. Located within 5.7 square miles and surrounded by the cities of Los Angeles and West Hollywood, it had a population of 34,109 at the 2010 census[10] and an estimated population of 34,183 in 2018.[8]',
          wiki: 'https://en.wikipedia.org/wiki/Beverly_Hills,_California',
        },
      ]
    },
    {
      overview: {
        no: 10,
        summary: `Today the entire day is free or visit optional tour of Universal studios, the work place of Hollywood’s biggest and most glamorous stars. Go on the legendry studio tram tour. Experience the newly opened ‘Wizarding World of Harry Potter’. Enjoy breathtaking rides like Transformers 3D, Jurassic park, Revenge of the Mummy and many more. `,
        title: 'Universal Studios (Optional)',
        startLoc: 'Los Angeles',
        endLoc: 'Los Angeles',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: 'Four Points by Sheraton, Los Angeles, CA, USA',
        map: 'https://www.google.com/maps/place/Four+Points+by+Sheraton+Los+Angeles+International+Airport/@33.9478964,-118.3872335,17z/data=!3m1!4b1!4m8!3m7!1s0x80c2b6d6f0f8d99b:0x2e42619821fb8a5b!5m2!4m1!1i2!8m2!3d33.947892!4d-118.3850448',
        contactNo: '',
        startDate: '17 May 2020',
        endDate: '18 May 2020'
      },
      attractions: [
        {
          name: 'tour of Universal studios',
          map: 'https://www.google.com/maps/place/Universal+Studios+Hollywood/@34.1381212,-118.355567,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be4f253238cf:0xd3dd5027799c9a71!8m2!3d34.1381168!4d-118.3533783',
          pics: [
            '10-1-1.jpg',
            '10-1-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Universal+Studios+Hollywood&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Universal Studios Hollywood is a film studio and theme park in the San Fernando Valley area of Los Angeles County, California. About 70% of the studio lies within the unincorporated county island known as Universal City while the rest lies within the city limits of Los Angeles, California. It is one of the oldest and most famous Hollywood film studios still in use.',
          wiki: 'https://en.wikipedia.org/wiki/Universal_Studios_Hollywood',
        },
        {
          name: ' the legendry studio tram tour',
          map: 'https://www.google.com/maps/place/Universal+Studios+Hollywood/@34.1381212,-118.355567,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be4f253238cf:0xd3dd5027799c9a71!8m2!3d34.1381168!4d-118.3533783',
          pics: [
            '10-2-1.jpg',
            '10-2-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=universal+studios+studio+tour&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Tour is the signature attraction at the park, and goes into a working film studio, with various film sets on the Universal Studios Lot. In recent years, guests have sat in multi-car trams for the duration of the ride. The Tour lasts about 45–60 minutes[1] and is led by a live tour guide who can be seen throughout the tram on video screens.',
          wiki: 'The Tour is the signature attraction at the park, and goes into a working film studio, with various film sets on the Universal Studios Lot. In recent years, guests have sat in multi-car trams for the duration of the ride. The Tour lasts about 45–60 minutes[1] and is led by a live tour guide who can be seen throughout the tram on video screens.',
        },
        {
          name: '‘Wizarding World of Harry Potter’',
          map: 'https://www.google.com/maps/place/The+Wizarding+World+Of+Harry+Potter/@34.1383973,-118.3559601,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be49258fcd69:0x907f5454583f35eb!8m2!3d34.1380863!4d-118.3533177',
          pics: [
            '10-3-1.jpg',
            '10-3-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Wizarding+World+of+Harry+Potter&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'The Wizarding World of Harry Potter is a chain of themed areas at Universal Parks & Resorts based on the Harry Potter media franchise, adapting elements from the Warner Bros. film series and original novels by the creative mind of J. K. Rowling. ',
          wiki: 'https://en.wikipedia.org/wiki/The_Wizarding_World_of_Harry_Potter',
        },
        {
          name: 'Transformers 3D rides',
          map: 'https://www.google.com/maps/place/Transformers:+The+Ride+3D/@34.1412697,-118.3590496,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be4810dac7e1:0xc9276019ba999272!8m2!3d34.1412653!4d-118.3568609',
          pics: [
            '10-4-1.jpg',
            '10-4-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Transformers%3A+The+Ride+3D&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Transformers: The Ride 3D (or simply Transformers: The Ride) is a 3D dark ride located at Universal Studios Singapore, Universal Studios Hollywood, Universal Studios Florida and upcoming to Universal Studios Beijing. The ride, based on the Transformers film franchise, was designed by Universal Creative, Oceaneering International, and Industrial Light & Magic. ',
          wiki: 'https://en.wikipedia.org/wiki/Transformers:_The_Ride_3D',
        },
        {
          name: ' Jurassic park rides',
          map: 'https://www.google.com/maps/place/Jurassic+Park+-+The+Ride/@34.1403501,-118.3591763,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be461cd333b1:0x1c234b1d53d581c6!8m2!3d34.1403457!4d-118.3569876',
          pics: [
            '10-5-1.jpg',
            '10-5-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=jurassic+park+ride&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Jurassic Park: The Ride is a water-based amusement ride based on the Steven Spielberg film Jurassic Park and Michael Crichton"s novel of the same name which the film is based on located at Universal Orlando"s Islands of Adventure in Orlando, Florida and Universal Studios Japan in Osaka, Japan.',
          wiki: 'https://www.google.com/maps/place/Jurassic+Park+-+The+Ride/@34.1403501,-118.3591763,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be461cd333b1:0x1c234b1d53d581c6!8m2!3d34.1403457!4d-118.3569876',
        },
        {
          name: 'Revenge of the Mummy rides',
          map: 'https://www.google.com/maps/place/Revenge+of+the+Mummy+-+The+Ride/@34.1406463,-118.3589801,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be486aded6d3:0x822047b2fc3cf159!8m2!3d34.1406419!4d-118.3567914',
          pics: [
            '10-6-1.jpg',
            '10-6-2.jpg'
          ],
          moreVids: '',
          morePics: 'https://duckduckgo.com/?q=Revenge+of+the+Mummy+rides&t=h_&iar=images&iaf=layout%3ATall&iax=images&ia=images',
          summary: 'Revenge of the Mummy, officially named Revenge of the Mummy: The Ride, is an enclosed roller coaster based on the Mummy film franchise, located at Universal Studios Florida, Universal Studios Hollywood, Universal Studios Singapore using linear induction motors (LIMs) to launch riders from a complete standstill to a top speed of between 40 and 45 mph (64 and 72 km/h) in a matter of seconds.',
          wiki: 'https://en.wikipedia.org/wiki/Revenge_of_the_Mummy',
        },
      ]
    },
    {
      overview: {
        no: 11,
        summary: `Today, proceed to the airport as your memorable tour with Thomas Cook comes to an end. Please do spare a few moments of your valuable time to write and share with us your wonderful experience. `,
        title: 'Fly Back To India',
        startLoc: 'San Fransisco',
        endLoc: 'Las Vegas',
      },
      dates: {
        startDate: '9 May 2020',
        endDate: '9 May 2020'
      },
      hotel: {
        name: '',
        map: '',
        contactNo: '',
      },
      attractions: [
        
      ]
    }
  ],
  contacts: [
    {
      name: 'Namrata (Visa Coord)',
      phone: '8898992446',
      email: ''
    },
    {
      name: 'Payal Desai',
      phone: '9821688977',
      email: 'payal.desai@in.thomascook.com'
    },
    {
      name: 'Diana Martin',
      phone: '9819122213',
      email: ' diana.martin2@in.thomascook.com'
    }
  ],
  pdf: {
    url: 'https://drive.google.com/open?id=0Bz9VL86vkIJmSEFacVNPSHdpNnRlLXRwczlYSk5sbzRIVTJj'
  },
  docs: {
    url: 'https://drive.google.com/open?id=1tp0xx-vZZEcuBWNepb-WWZpsXjK265Yi'
  },
  corona: {
    primary: [
      {
        text: 'Advice To Public',
        url: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public'
      },
      {
        text: 'FAQs on Virus',
        url: 'https://www.who.int/news-room/q-a-detail/q-a-coronaviruses'
      },
      {
        text: 'Condition Overview',
        url: 'https://www.who.int/health-topics/coronavirus'
      },
      {
        text: 'Interactive Map',
        url: 'https://infographics.channelnewsasia.com/covid-19/map.html'
      }
    ],
    secondary: [
      {
        text: 'USA News Updates',
        url: 'https://www.google.com/search?biw=1920&bih=969&tbm=nws&ei=yUphXv7PBObgz7sPrqCJuAE&q=coronavirus+USA+update&oq=coronavirus+USA+update&gs_l=psy-ab.3..0.13781.15992.0.16660.7.5.0.2.2.0.129.256.0j2.2.0....0...1c.1.64.psy-ab..3.4.263....0.5NgxDr7H908'
      },
      {
        text: 'India News Updates',
        url: 'https://www.google.com/search?biw=1920&bih=969&tbm=nws&ei=2kphXo-uFpbgz7sP6qOS4Ag&q=coronavirus+india+update&oq=coronavirus+india+update&gs_l=psy-ab.3..0.39042.39953.0.40208.6.6.0.0.0.0.327.636.0j2j0j1.3.0....0...1c.1.64.psy-ab..4.2.445...0i13k1.0.gwD0ho-j8mI'
      },
      {
        text: 'General News Updates',
        url: 'https://www.google.com/search?q=coronavirus+news&source=lnms&tbm=nws&sa=X&ved=2ahUKEwjf2_LmgIToAhVn8XMBHdMEBg0Q_AUoAXoECAsQAw&biw=1920&bih=969'
      }
    ]
  }
}

export default schedule
